import { toAbsoluteUrl } from '../../../../_metronic/helpers/AssetHelpers'
import infoLightIcon from '../../../../media/shared-access/ic-info-lit.svg'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { useEffect, useState } from 'react'
// import {Link} from 'react-router-dom'
import '../style/contact.scss'
import { Country } from '../../widgets/components/General/Country'
import { Formik, Form } from 'formik'
import { useIntl } from 'react-intl'
import * as Yup from 'yup'
import TextInput from '../../widgets/components/Input/TextInput'
import { createContact, updateContact } from '../core/_requests'
import { toast } from 'react-toastify'
import { useAuth } from '../../../../app/modules/auth'
import '../style/addcontact.scss'
import CreatableSelect from 'react-select/creatable'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../hooks/gtmHelpers'
import brandingConfig from '../../../../config/brandingConfig'

export const AddContact = ({
  isNewContactActive,
  selectedContact,
  groups,
  setIsNewContactActive,
  setcontacts,
  setselectedContact,
  isSubmitting,
  setIsSubmitting,
}: any) => {
  const [selectedGroups, setSelectedGroups] = useState<object[]>([])
  const { formatMessage } = useIntl()
  const { companyId, currentUser } = useAuth()
  const [modelStatus, setModelStatus] = useState<boolean>(false) // eslint-disable-line
  const [countryId, setCountryId] = useState<string | undefined>('') // eslint-disable-line
  const [imgName, setImgName] = useState<string | undefined>() // eslint-disable-line
  const [groupData, setgroupData] = useState([]) // eslint-disable-line
  const [searchGroup, setSearchGroup] = useState() // eslint-disable-line

  const initialValues = {
    profilePicture: isNewContactActive === 'Edit' ? selectedContact.pictureUrl || '' : '',
    name: isNewContactActive === 'Edit' ? selectedContact.givenName || '' : '',
    companyName: isNewContactActive === 'Edit' ? selectedContact.companyName || '' : '',
    designation: isNewContactActive === 'Edit' ? selectedContact.jobTitle || '' : '',
    email: isNewContactActive === 'Edit' ? selectedContact?.emails?.[0]?.email || '' : '',
    phone: isNewContactActive === 'Edit' ? selectedContact?.phoneNumbers?.[0]?.number || '' : '',
    city: isNewContactActive === 'Edit' ? selectedContact?.physicalAddresses?.[0]?.city || '' : '',
    notes: isNewContactActive === 'Edit' ? selectedContact?.notes || '' : '',
    country: '',
  }

  const validationSchema: Yup.ObjectSchema<any> = Yup.object().shape({
    name: Yup.string(),
    designation: Yup.string(),
    email: Yup.string().when(['companyName', 'phone'], {
      is: (companyName: any, phone: any) => !companyName && !phone,
      then: Yup.string()
        .email(formatMessage({ id: 'Invalid email format' }))
        .required(formatMessage({ id: 'Email is required' })),
      otherwise: Yup.string().email(formatMessage({ id: 'Invalid email format' })),
    }),
    phone: Yup.string()
      .transform((value, originalValue) => (originalValue ? originalValue.replace(/\D/g, '') : ''))
      .matches(/^\d{10}$/, formatMessage({ id: 'Phone number must be exactly 10 digits' })),
    country: Yup.string().when('phone', {
      is: (phone: any) => !!phone,
      then: Yup.string().required(formatMessage({ id: 'Country is required' })),
    }),
  })

  function transformArray(group: any) {
    const newArray = group
      .filter(
        (item: any) =>
          item.groupType === 'user' || item.name === 'starred' || item.name === 'myContacts'
      )
      .map((item: any) => ({
        value: item.id,
        label: item.name,
      }))
    return newArray
  }

  const handleSelectChange = (selectedOptions: any) => {
    setSelectedGroups(selectedOptions)
  }

  const onSubmit = async (values: any, formik: any) => {
    setIsSubmitting(true)
    const selectedGroupIds = selectedGroups?.map((group: any) => {
      return { id: group.value }
    })
    console.log('Form Values:', values, searchGroup, selectedGroups, selectedGroupIds)
    try {
      const payload = {
        ...values,
        profilePicture: imgName,
        groups: selectedGroupIds,
        phone: `${values.phone}`,
      }
      const {
        data: { data, success, errors },
      } =
        isNewContactActive === 'Edit'
          ? await updateContact(companyId!, payload, selectedContact.id)
          : await createContact(companyId!, payload)
      if (success) {
        if (isNewContactActive === 'Edit') {
          toast.success(formatMessage({ id: 'Contact updated successfuly.' }))
          setcontacts((prevContacts: any) =>
            prevContacts.map((userContact: any) =>
              userContact.id === data?.data?.id ? data?.data : userContact
            )
          )
          setselectedContact(data?.data)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ContactUpdateSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                contact_name: data.data.givenName || '',
                contact_id: data.data.id,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        } else {
          toast.success(formatMessage({ id: 'Contact created successfuly.' }))
          console.log('contact success check', data)
          setcontacts((prevContacts: any) => [...prevContacts, data?.contact?.data])
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.ContactCreateSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                contact_name: data.contact.data.givenName || '',
                contact_id: data.contact.data.id,
                user_id: currentUser?.userId,
                email: currentUser?.email,
              },
            },
          })
        }
      } else {
        console.log('check error contact', errors)
        if (errors.length > 0) {
          toast.error(formatMessage({ id: `${errors[0]}` }))
        } else {
          toast.error(
            formatMessage({
              id: `Something went wrong while creating contact. Please check your details.`,
            })
          )
        }
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.ContactCreateOrUpdateFailed,
            action: 'normal',
            metadata: {
              errors: errors[0],
              company_id: companyId,
              contact_name: data.contact.data.givenName || '',
              user_id: currentUser?.userId,
              email: currentUser?.email,
            },
          },
        })
      }
    } catch (err) {
      console.log(err)
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.ContactCreationFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            errors: err,
          },
        },
      })
    } finally {
      setIsSubmitting(false)
      setSelectedGroups([])
      formik.resetForm()
      setIsNewContactActive('Detail')
    }
  }

  const DropdownIndicator = () => {
    return (
      <div className='me-3'>
        <img src={toAbsoluteUrl('/media/icons/investor/DownArrow.svg')} alt='search' />
      </div>
    )
  }
  const customStyles = {
    placeholder: (provided: any, state: any) => ({
      ...provided,
      fontSize: 13,
      fontWeight: 500,
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      '&:focus': {
        boxShadow: 'none',
      },
      fontSize: 13,
      padding: 0,
    }),
    control: (baseStyles: any, state: any) => ({
      ...baseStyles,
      borderColor: state.isFocused ? '#b5b5c3' : '#e4e6ef',
      boxShadow: 'none',
      minHeight: '43px',
      maxHeight: '80px',
      overflowY: 'scroll',
    }),
    option: (styles: any, state: any) => ({
      ...styles,
      color: state.isSelected ? '#FFF' : styles.color,
      '&:hover': {
        color: '#4776E6',
        backgroundColor: '#E1E7ED',
      },
    }),
  }

  useEffect(() => {
    const transformedArray = transformArray(groups)
    setgroupData(transformedArray)
  }, [groups])

  useEffect(() => {
    if (isNewContactActive === 'Edit' && selectedContact?.groups) {
      const transformedExtArray = transformArray(selectedContact.groups)
      console.log('ext', selectedContact)
      setSelectedGroups(transformedExtArray)
    } else {
      setSelectedGroups([])
    }
  }, [isNewContactActive, selectedContact])

  return (
    <>
      <div className='card' id='kt_contacts_main'>
        <div className='card-header' id='kt_chat_contacts_header'>
          <div className='card-title m-0'>
            {isNewContactActive === 'Edit'
              ? formatMessage({ id: 'Update Contact' })
              : formatMessage({ id: 'Add New Contact' })}
          </div>
        </div>
        <div className='card-body-padd '>
          <InfoCard2
            title='Integrated Contact Management'
            desc={`Easily create and add new contacts to your Company in ${brandingConfig.brandName}. Collaboratively manage all your contacts from one place for streamlined communication.`}
            slug={brandingConfig.helpLinks.sharedAccessContacts}
          />
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            enableReinitialize={true}
            onSubmit={(values, formik) => onSubmit(values, formik)}
            validateOnMount
          >
            {(formik) => (
              <Form id='kt_ecommerce_settings_general_form' className='form'>
                {/* <div className='mb-7'>
                  <label
                    className='form-label fs-6 fw-semibold text-gray-500 text-capitalize mb-3'
                    htmlFor='kt_login_toc_agree '
                  >
                    Profile Picture
                    <ToolTipUI tooltipText={'Allowed file types: png, jpg, jpeg.'} />
                  </label>
                  <div className='mt-1'>
                    <div
                      className={`card position-relative d-inline-block justify-content-center m-0`}
                      onClick={handleOpen}
                    >
                      <DisplayImage
                        imgName={imgName}
                        width={120}
                        height={120}
                        fit='contain'
                        alt='profile'
                      />
                      <div className='pencil-container position-absolute top-0 right-0'>
                        <img
                          src={toAbsoluteUrl('/media/icons/duotune/general/pencil.svg')}
                          alt=''
                        />
                      </div>
                    </div>
                    <FileUpload
                      fileSize={2097152}
                      maxFileNumber={1}
                      allowType={['image/*', '.jpg', '.jpeg', '.png']}
                      metaData={{module: 'logo', isProtected: false}}
                      modalStatus={modelStatus}
                      handleClose={handleClose}
                      handleSuccess={(id: number, name: string) => {
                        setImgName(name)
                        formik.setFieldValue('logoId', id)
                      }}
                    />
                    <div className='text-gray-500  font-size-12 mt-3 w-md-250px w-100 text-md-start text-center'>
                      <span>{formatMessage({id: 'Max size 2mb, supported'})} </span>
                      {formatMessage({id: 'format jpg, png'})}
                    </div>
                  </div>
                </div> */}

                <div className='row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2'>
                  <div className='col mt-4'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'Name' })}
                      fieldName={'name'}
                      placeholder={formatMessage({ id: "Enter the contact's name." })}
                      formik={formik}
                      toolTipText={formatMessage({ id: "Enter the contact's name." })}
                    />
                  </div>
                  <div className='col mt-4'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'Company Name (if any)' })}
                      fieldName={'companyName'}
                      placeholder={formatMessage({ id: 'Enter the Company Name' })}
                      formik={formik}
                      toolTipText={formatMessage({ id: 'Enter the Company Name (optional).' })}
                    />
                  </div>
                </div>

                <div className='row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2'>
                  <div className='col mt-2'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'Designation (if any)' })}
                      fieldName={'designation'}
                      placeholder={formatMessage({ id: 'Enter the Designation.' })}
                      formik={formik}
                      toolTipText={formatMessage({ id: 'Enter the Designation.' })}
                    />
                  </div>
                  <div className='col mt-2'>
                    <TextInput
                      fieldType={'email'}
                      label={formatMessage({ id: 'Email' })}
                      fieldName={'email'}
                      placeholder={formatMessage({ id: 'Enter the Email.' })}
                      formik={formik}
                      toolTipText={formatMessage({ id: 'Enter the Email.' })}
                      isStarRequired={false}
                    />
                  </div>
                </div>

                <div className='row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2'>
                  <div className='col mt-2'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'Phone' })}
                      fieldName={'phone'}
                      placeholder={formatMessage({ id: 'Enter the Phone number.' })}
                      formik={formik}
                      toolTipText={formatMessage({ id: 'Enter the Phone number.' })}
                    />
                  </div>
                  <div className='col mt-2'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'City' })}
                      fieldName={'city'}
                      placeholder={formatMessage({ id: 'Enter City' })}
                      formik={formik}
                      toolTipText={formatMessage({ id: 'Enter City' })}
                    />
                  </div>
                </div>

                <div className='row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2'>
                  <div className='col mt-2'>
                    <TextInput
                      fieldType={'text'}
                      label={formatMessage({ id: 'Note' })}
                      fieldName={'notes'}
                      placeholder={formatMessage({ id: "Enter the contact's note." })}
                      formik={formik}
                      toolTipText={formatMessage({ id: "Enter the contact's note (optional)." })}
                    />
                  </div>
                  <div className='col mt-2'>
                    <div className='w-100'>
                      <Country
                        initialValues={initialValues}
                        formik={formik}
                        label={formatMessage({ id: 'Country' })}
                        setCountryId={setCountryId}
                        tooltipText={formatMessage({ id: 'Enter the country.' })}
                        width={12}
                        isStarRequired={false}
                      />
                    </div>
                  </div>
                </div>
                <div className='row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2'>
                  <div className='fv-row mb-7'>
                    <label className='fs-6 fw-semibold form-label mt-3'>
                      <span>{formatMessage({ id: 'Add to Group' })}</span>
                      <span
                        className='ms-1'
                        data-bs-toggle='tooltip'
                        title={formatMessage({ id: 'Enter the name of group to add.' })}
                      >
                        <img src={infoLightIcon} alt='' />
                      </span>
                    </label>
                    <CreatableSelect
                      isMulti
                      closeMenuOnSelect={false}
                      name='searchGroup'
                      options={groupData}
                      onCreateOption={() => {
                        return
                      }}
                      formatCreateLabel={() => formatMessage({ id: 'No Group Found.' })}
                      placeholder={formatMessage({ id: 'Search Group' })}
                      maxMenuHeight={200}
                      classNames={{
                        control: (state: any) =>
                          state.isFocused ? 'border-red-600' : 'border-grey-300',
                      }}
                      classNamePrefix='react-select'
                      styles={customStyles}
                      components={{ DropdownIndicator }}
                      value={selectedGroups}
                      onChange={handleSelectChange}
                      theme={(theme: any) => ({
                        ...theme,
                        border: 0,
                        borderRadius: 5,
                        colors: {
                          ...theme.colors,
                          primary25: '#E1E7ED',
                          primary: '#e4e6ef',
                        },
                      })}
                    />
                  </div>
                </div>

                <div className='separator mb-6'></div>
                <div className='d-flex justify-content-end'>
                  <button
                    type='reset'
                    data-kt-contacts-type='cancel'
                    className='btn btn-light me-3'
                    onClick={() => setIsNewContactActive('Detail')}
                    disabled={isSubmitting}
                  >
                    {formatMessage({ id: 'Discard' })}
                  </button>
                  <button
                    type='submit'
                    data-kt-contacts-type='submit'
                    className='btn btn-primary'
                    disabled={isSubmitting}
                  >
                    {isSubmitting
                      ? isNewContactActive === 'Edit'
                        ? formatMessage({ id: 'Updating...' })
                        : formatMessage({ id: 'Submitting...' })
                      : isNewContactActive === 'Edit'
                        ? formatMessage({ id: 'Update Contact' })
                        : formatMessage({ id: 'Submit' })}
                    {/* <span className='indicator-label'>Save</span>
                    <span className='indicator-progress'>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span> 
                    </span> */}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  )
}
